import { render } from "./SideMenuDark.vue?vue&type=template&id=37fc6541"
import script from "./SideMenuDark.vue?vue&type=script&lang=js"
export * from "./SideMenuDark.vue?vue&type=script&lang=js"

import exportComponent from "/tmp/build_1ea34a31/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__